
import React, { useEffect, useState, useContext } from "react";
import Table from "../Shared/Table";

import { Card, CardBody, CardHeader, CardTitle, Row, Col, ListGroup, ListGroupItem, Button, Modal, ModalBody, ModalFooter } from "reactstrap";

import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useParams, useHistory } from "react-router-dom";
import { building as buildingEndpoint } from "core/UrlEndpoints";
import elevatorCompanyService from "core/api/ElevatorCompanyService";
import SettingsManagementService from "core/api/SettingsManagementService";
import HeaderInfoItem from "../Shared/HeaderInfoItem";
import { CrudDropdownEditDelete } from "../Shared/CrudDropdownEditDelete";
import { UserContext } from "context/UserContext";

const DIDLineType = {
  Emergency: "Emergency",
  CustomerService: "Customer Service"
};

const View = () => {
  const history = useHistory();
  const { id } = useParams();
  const { userHasAnyPermissions } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [defaultTimeout, setDefaultTimeout] = useState();
  const [invitePopup, setInvitePopup] = useState({ visible: false, contactPhone: "", contactName: "" });
  const [inviteSentPopup, setInviteSentPopup] = useState(false);

  const sendInvite = async () => {
    await elevatorCompanyService.sendSmsInvite({ elevatorCompanyId: id, contactPhone: invitePopup.contactPhone });
    setInvitePopup({ visible: false, contactPhone: "", contactName: "" });
    setInviteSentPopup(true);
  };

  const [companyData, setCompanyData] = useState({
    id: "",
    name: "",
    line1: "",
    line2: "",
    city: "",
    state: "NY",
    postalCode: "",
    country: "USA",
    dids: [],
    smsDID: "",
    contacts: [],
    sendSummaryReport: false,
    summaryReportDeliveryMode: "",
    communicateThroughSMS: false,
    callTimeoutSetting: null
  });

  useEffect(() => {
    async function fetchData() {
      const results = await elevatorCompanyService.get(id);
      const setting = await SettingsManagementService.getByName('DefaultDispatchTimeoutMinutes');
      setCompanyData(results);
      setDefaultTimeout(setting?.value);
      setLoading(false);
    }
    fetchData();
  }, [id]);

  if (loading) return <>Loading</>;

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h1 className="title">
              {companyData?.name}
            </h1>
          </div>
        }
      />
      <div className="content">
        <Row>
          <Col xs={12} md={12}>

            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <CardTitle tag="h4">Company Information</CardTitle>
                <Col xs="auto">
                  <CrudDropdownEditDelete
                    onDelete={() => {
                      elevatorCompanyService.delete(id);
                      history.goBack();
                    }}
                    deletePermissions={["all:elevator_companies", "delete:elevator_companies", "admin"]}
                    editPermissions={["all:elevator_companies", "write:elevator_companies", "admin"]}
                  />
                </Col>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <ListGroup>
                      <ListGroupItem>
                        <strong>Company Name:</strong> {companyData.name}
                      </ListGroupItem>
                      <ListGroupItem>
                        <strong>Address:</strong> {companyData.line1} {companyData.line2}, {companyData.city}, {companyData.state} {companyData.postalCode}
                      </ListGroupItem>
                      <ListGroupItem>
                        <strong>SMS DID:</strong> {companyData.smsDID || ""}
                      </ListGroupItem>
                      <ListGroupItem>
                        <strong>Email Summary Report:</strong> {companyData.sendSummaryReport ? "Yes" : "No"}
                      </ListGroupItem>
                      {companyData.sendSummaryReport && (
                        <ListGroupItem>
                          <strong>Summary Report Delivery Mode:</strong> {companyData.summaryReportDeliveryMode || ""}
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        <strong>Communicate Through SMS:</strong> {companyData.communicateThroughSMS ? "Yes" : "No"}
                      </ListGroupItem>
                      <ListGroupItem>
                        <strong>Dispatch Timeout Setting:</strong> {companyData.callTimeoutSetting || defaultTimeout} minutes
                      </ListGroupItem>
                      <ListGroupItem>
                        <strong>DIDs:</strong>
                        <div style={{ marginLeft: "30px", marginTop: "10px" }}>
                          {companyData.dids?.map((did, index) => (
                            <Row key={index} style={{ marginBottom: "10px", paddingBottom: "10px", borderBottom: index < companyData.dids.length - 1 ? "1px solid #eee" : "none" }}>
                              <Col xs={12} md={2}>
                                <HeaderInfoItem title="Phone Number">
                                  {did.phoneNumber}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={12} md={2}>
                                <HeaderInfoItem title="Line Type">
                                  {DIDLineType[did.lineType] || DIDLineType.Emergency}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={12} md={6}>
                                <HeaderInfoItem title="Comments">
                                  {did.comments || "-"}
                                </HeaderInfoItem>
                              </Col>
                            </Row>
                          ))}
                        </div>
                      </ListGroupItem>
                      
                      <ListGroupItem>
                        <strong>Contacts:</strong>
                        <div style={{ marginLeft: "30px", marginTop: "10px" }}>
                          {companyData.contacts?.map((contact, index) => (
                            <Row key={index} style={{ marginBottom: "10px", paddingBottom: "10px", borderBottom: index < companyData.contacts.length - 1 ? "1px solid #eee" : "none" }}>
                              <Col xs={12} md={2} >
                                <HeaderInfoItem title={contact.defaultContact ? "Name (Default)" : "Name"}>
                                  {contact.contactName}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={12} md={2} >
                                <HeaderInfoItem title="Phone">
                                  {contact.phone}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={12} md={3} >
                                <HeaderInfoItem title="Email">
                                  {contact.email || "-"}
                                </HeaderInfoItem>
                              </Col>
                           
                              <Col xs={6} md={1}>
                                <HeaderInfoItem title="Help SMS">
                                  {contact.smsWhenHelpNeeded ? "Yes" : "No"}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={6} md={1}>
                                <HeaderInfoItem title="Service SMS">
                                  {contact.smsForCustomerServiceReport ? "Yes" : "No"}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={6} md={1}>
                                <HeaderInfoItem title="SMS Summary">
                                  {contact.smsSummaryCallReport ? "Yes" : "No"}
                                </HeaderInfoItem>
                              </Col>   
                              <Col xs={6} md={1}>
                                <HeaderInfoItem title="Logged On">
                                  {contact.loggedOnToReceiveSMS ? "Yes" : "No"}
                                </HeaderInfoItem>
                              </Col>
                              <Col xs={6} md={1}>
                                <Button
                                  color="info"
                                  outline
                                  size="sm"
                                  style={{ margin: 0, fontSize: "12px", padding: "4px 8px" }}
                                  onClick={() => setInvitePopup({ visible: true, contactPhone: contact.phone, contactName: contact.contactName })}
                                >
                                  Send SMS Invite
                                </Button>
                              </Col>
                            </Row>
                          ))}
                        </div>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row> 
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle tag="h4">Buildings</CardTitle>
                {userHasAnyPermissions(["all:buildings", "write:buildings", "admin"]) &&
                  <Button
                    color="primary"
                    onClick={() => history.push(`../buildings/company/${id}/add`, { showBackButton: true })}>
                    Add
                  </Button>
                }
              </CardHeader>
              <CardBody>
                <Table
                  pathroot="/admin/buildings"
                  url={buildingEndpoint}
                  filters={{ ElevatorCompanyId: id }}
                  columns={[
                    {
                      header: "Building Name",
                      accessorKey: "buildingName",
                    },
                    {
                      header: "Customer",
                      accessorKey: "customerName",
                    },
                    {
                      header: "Address",
                      accessorKey: "line1",
                      cell: ({ row }) => (
                        <>
                          {row.original.line1} {row.original.line2},{" "}
                          {row.original.city} {row.original.state}
                        </>
                      ),
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal isOpen={invitePopup.visible} centered={true}>
        <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
          <div className="title" style={{ fontSize: 18 }}>Send SMS Invite</div>
          <i className="now-ui-icons ui-1_send" style={{ fontSize: 40, color: "#2CA8FF" }}></i>
          <p style={{ fontSize: 16 }}>Do you want to send an invite to {invitePopup.contactName} at {invitePopup.contactPhone}?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" outline onClick={() => setInvitePopup({ visible: false, contactPhone: "", contactName: "" })} style={{ margin: "auto", display: "block" }}>Cancel</Button>
          <Button color="primary" onClick={sendInvite} style={{ margin: "auto", display: "block" }}>Send</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={inviteSentPopup} centered={true}>
        <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
          <div className="title" style={{ fontSize: 18 }}>Invite Sent!</div>
          <i className="now-ui-icons ui-1_send" style={{ fontSize: 40, color: "#2CA8FF" }}></i>
          <p style={{ fontSize: 16 }}>SMS invite was sent successfully.</p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setInviteSentPopup(false)} style={{ margin: "auto", display: "block" }}>OK</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default View;
